export default "__VITE_ASSET__vtBs$rWS__"